import { IReport, Report } from "./report.model";

export interface IReportsResponse {
  pendings: IReport[];
  inProgress: IReport[];
  resolved: IReport[];
  /* Cuarta bandeja: reportes con active = 0. Un cancelado CONSERVA su status,
     por lo que el backend excluye los inactivos de las otras tres bandejas; si
     no lo hiciera, el mismo reporte aparecería duplicado en dos pestañas. */
  canceled: IReport[];
}

export class ReportsResponse {
  pendings: Report[];
  inProgress: Report[];
  resolved: Report[];
  canceled: Report[];

  [key: string]: Report[];

  constructor(data: IReportsResponse) {
    this.pendings = data.pendings
      ? data.pendings.map(
          (report) => new Report(report)
        )
      : [];
      
    this.inProgress = data.inProgress
      ? data.inProgress.map(
          (report) => new Report(report)
        )
      : [];
      
    this.resolved = data.resolved
      ? data.resolved.map(
          (report) => new Report(report)
        )
      : [];

    this.canceled = data.canceled
      ? data.canceled.map(
          (report) => new Report(report)
        )
      : [];
  }
}
